export default __webpack_public_path__ + "static/media/slide13.55ebda60.jpg";